(function() {
    'use strict';

    angular.module('GorillaBoy')
    .controller('sendMessageModalCtrl', [
        '$rootScope',
        '$scope',
        '$q',
        '$translate',
        '$uibModalInstance',
        'authenticatedUser',
        'AppConstants',
        'SignalProvider',
        'MessageProvider',
        'MessageManager',
        'DocumentStateService',
        'DocumentService',
        'documentId',
        'scopeUser',
        'DocumentUtilities',
        'documentState',
        sendMessageModalController
    ]);

    function sendMessageModalController($rootScope, $scope, $q, $translate, $uibModalInstance, authenticatedUser, AppConstants, SignalProvider,
            MessageProvider, MessageManager, DocumentStateService, DocumentService, documentId, scopeUser, DocumentUtilities, documentState) {
        var isSendingMessage = false,
            feedbackListMap = documentState.feedbackListMap,
            documentVersionCommentsMap = documentState.documentVersionCommentsMap,
            feedbackTypes = AppConstants.FeedbackTypes;

        $scope.message = '';
        $scope.errorText = '';
        var latestVersionId = DocumentUtilities.getLatestNonDraftVersionId(documentState.documentVersions);

        $scope.closeModal = function() {
            $uibModalInstance.dismiss();
        };

        $scope.submitMessage = function(form) {
            if (form.$invalid || isSendingMessage) {
                return;
            }

            isSendingMessage = true;

            var data = {
                message: $scope.message
            };

            sendMessage(data).then(function() {
                $uibModalInstance.close();
                isSendingMessage = false;
                // Refresh the feedback panel
                $rootScope.$broadcast(SignalProvider.Feedback.Refresh, latestVersionId);
                MessageManager.addSuccessMessage(MessageProvider.messageSendingSuccess);
            }, function(errorText) {
                isSendingMessage = false;
                $scope.errorText = errorText;
            });
        };

        $scope.enterToSubmit = function($event, sendMessageForm) {
            if ($event.which === AppConstants.KeyCodes.ENTER && !$event.shiftKey) {
                $event.preventDefault();
                $scope.submitMessage(sendMessageForm);
            }
            return false;
        };

        function sendMessage(data) {
            var done = $q.defer();

            if (!angular.isDefined(data.message) || data.message === '') {
                done.reject($translate.instant('MESSAGES.SEND_MESSAGES_ERROR'));
            } else {

                //TODO(qizhou): Refactor it in to a service since publishOverallComment in feedbackInput also calls it and does the same thing
                DocumentService.postDocumentComment({
                    DocumentId : documentId,
                    VersionId : latestVersionId,
                    Text : data.message
                }, true)
                .then(function(response) {
                    var data = response.data,
                        user = authenticatedUser.getUserInfo();

                    //Update the count of the user's comments
                    if (!documentState.userToFeedbackCountMap[user.Id]) {
                        documentState.userToFeedbackCountMap[user.Id] = 0;
                    }
                    if (!documentVersionCommentsMap[latestVersionId]) {
                        documentVersionCommentsMap[latestVersionId] = 0;
                    }
                    documentVersionCommentsMap[latestVersionId] += 1;
                    documentState.userToFeedbackCountMap[user.Id] += 1;
                    var commentObj = {
                        DocumentId : documentId,
                        VersionId : latestVersionId,
                        CommentId: data.CommentId,
                        Contributor: user ? user : scopeUser,
                        Text: data.Text,
                        isVisible: true,
                        Visibility : AppConstants.FEEDBACK_VISIBILITY.PUBLIC,
                        Created: new Date(),
                        CommentStatus: feedbackTypes.FEEDBACK_TYPE_PUBLISHED
                    };
                    var processedText = DocumentUtilities.parseTextAndEmbedMarkdownForEmails(commentObj.Text);
                    commentObj.MarkupText = remarkableMd.render(processedText);
                    var currentfeedbackSection = [];
                    angular.forEach(feedbackListMap[latestVersionId], function(feedbackSection) {
                        if (feedbackSection.title === AppConstants.DOC_LEVEL) {
                            currentfeedbackSection.push(feedbackSection);
                        }
                    });

                    if (currentfeedbackSection.length > 0) {
                        //Use .push() method instead of unshift because we want the new comment to come at the end
                        currentfeedbackSection[0].push(commentObj);
                    } else {
                        var feedbackSection = [];
                        feedbackSection.title = AppConstants.DOC_LEVEL;
                        feedbackSection.marker = 0;
                        feedbackSection.unshift(commentObj);
                        if (!feedbackListMap[latestVersionId]) {
                            feedbackListMap[latestVersionId] = [];
                        }
                        feedbackListMap[latestVersionId].unshift(feedbackSection);
                    }
                    done.resolve(data);
                }, function(data, status, headers, config) {
                    /* Anything to display? */
                    done.reject(data);
                });
            }
            return done.promise;
        }
    }
}());
